import { render, staticRenderFns } from "./CurrencyExchangeRateRow.vue?vue&type=template&id=6504b191&"
import script from "./CurrencyExchangeRateRow.vue?vue&type=script&lang=js&"
export * from "./CurrencyExchangeRateRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports